const tenant = process.env.VITE_TENANT;
if (!tenant) throw new Error('Missing tenant variable');

// Do not use the cross origin setup if the local environment is proxied behind a different host.
// This is the case for Github Codespaces with private port forwarding.
const shouldUseCrossOriginSetup = typeof window !== 'undefined' && window.location.hostname === 'localhost';
const developmentUrl = shouldUseCrossOriginSetup ? 'http://localhost:3080' : '/api';

const apiUrls = {
  development: developmentUrl,
  staging: tenant === 'shared' ? 'https://api.staging.pingwire.io' : `https://api.${tenant}.staging.pingwire.io`,
  production: tenant === 'shared' ? 'https://api.pingwire.io' : `https://api.${tenant}.pingwire.io`,
} as const;

const connectSrcUrls = {
  development: 'http://localhost:3080',
  staging: apiUrls.staging,
  production: apiUrls.production,
} as const;

// The form app runs on its own origin and is framed by the Form Studio preview.
// In Codespaces, it is served from the forwarded port 8084.
const frameSrcUrls = {
  development: 'http://localhost:8084 https://*-8084.app.github.dev',
  staging: tenant === 'shared' ? 'https://form.staging.pingwire.io' : `https://form.${tenant}.staging.pingwire.io`,
  production: tenant === 'shared' ? 'https://form.pingwire.io' : `https://form.${tenant}.pingwire.io`,
} as const;

const fileStorageUrls = {
  development: 'http://localhost:4567',
  staging: tenant === 'shared' ? 'https://filestorage.staging.pingwire.io' : `https://filestorage.${tenant}.staging.pingwire.io`,
  production: tenant === 'shared' ? 'https://filestorage.pingwire.io' : `https://filestorage.${tenant}.pingwire.io`,
} as const;

const targetEnv = process.env.VITE_TARGET_ENV;
if (!targetEnv) throw new Error('Missing targetEnv variable');

const config = {
  targetEnv,
  tenant,
  apiUrl: apiUrls[targetEnv as 'development' | 'staging' | 'production'],
  connectSrcUrl: connectSrcUrls[targetEnv as 'development' | 'staging' | 'production'],
  frameSrcUrl: frameSrcUrls[targetEnv as 'development' | 'staging' | 'production'],
  fileStorageUrl: fileStorageUrls[targetEnv as 'development' | 'staging' | 'production'],
  sentryEnvironment: targetEnv,
  sentryEnabled: !!targetEnv && targetEnv !== 'development',
  reportOutputConfigurationEnabled: true,
};

export default config;
